module.exports = __webpack_public_path__ + "img/dv360.b403320.png";